<nav role="navigation" class="align-items-end desktop">
    <ul class="ps-0">
        @for (route of getRoutes(); track $index) {
            @if (isMenuItemDisplayed(route)) {
                <ng-container>
                    <!-- No child -->
                    @if ((!route.children || (route.children && route.children.length === 0))) {
                        <li class="me-3" [routerLink]="route.path" routerLinkActive="active">
                            {{route.data?.title | translate}}
                        </li>
                    }

                    <!-- Has children -->
                    @if (route.children && route.children.length > 0) {
                        <li
                            class="me-3"
                            [matMenuTriggerFor]="menu"
                            #trigger="matMenuTrigger"
                            aria-haspopup="true"
                            aria-expanded="false"
                            [class.active]="isChildRouteActive(route)"
                        >
                            {{route.data?.title | translate}}
                        </li>

                        <mat-menu
                            class="py-3 px-2"
                            #menu="matMenu"
                            direction="down"
                            yPosition="below"
                            role="menu"
                            attr.aria-label="{{ 'navigation.aria.menu_navigation' | translate }}"
                        >
                            @for (child of route.children; track $index) {
                                @if (isMenuItemDisplayed(child) && child.data?.title) {
                                    <button
                                        mat-menu-item
                                        [routerLink]="route.path + '/' + child.path"
                                    >
                                        {{child.data?.title | translate}}
                                    </button>
                                }
                            }
                        </mat-menu>
                    }
                </ng-container>
            }
        }
    </ul>
</nav>
<nav class="mobile" role="navigation">
    <ul>
        @for (route of getRoutes(); track $index) {
            @if (isMenuItemDisplayed(route) && route.data?.title) {
                @if (route.path) {
                    <li (click)="close()" role="navigation" (keyup)="close()" class="pointer" routerLinkActive="active" [routerLink]="route.path">
                        {{route.data?.title | translate}}
                    </li>
                }

                <!-- Has children -->
                @if (route.children && route.children.length > 0) {
                    @for (child of route.children; track $index) {
                        @if (isMenuItemDisplayed(child)) {
                            <li (click)="close()" role="navigation" (keyup)="close()" class="pointer" routerLinkActive="active" [routerLink]="route.path + '/' + child.path">
                                {{child.data?.title | translate}}
                            </li>
                        }
                    }
                }
            }
        }
    </ul>
</nav>